function normalizeLocationValue(value) {
  return typeof value === 'string' ? value.trim().toLowerCase() : ''
}

function findExactProvinceData(hardnessData, provinceName) {
  const normalizedProvince = normalizeLocationValue(provinceName)

  if (!normalizedProvince) return null

  return hardnessData.find(
    ({ province }) => normalizeLocationValue(province) === normalizedProvince,
  ) ?? null
}

function findExactCityData(provinceData, cityName) {
  const normalizedCity = normalizeLocationValue(cityName)

  if (!normalizedCity) return null

  return provinceData?.cities.find(
    ({ name }) => normalizeLocationValue(name) === normalizedCity,
  ) ?? null
}

export function resolveHardnessDeepLink(search = '', hardnessData = []) {
  const params = search instanceof URLSearchParams
    ? search
    : new URLSearchParams(String(search).replace(/^\?/, ''))
  const provinceData = findExactProvinceData(
    hardnessData,
    params.get('province'),
  )
  const cityData = provinceData
    ? findExactCityData(provinceData, params.get('city'))
    : null
  const result = provinceData && cityData
    ? {
        province: provinceData.province,
        city: cityData.name,
        hardness: cityData.hardness,
      }
    : null

  return {
    province: provinceData?.province ?? '',
    city: cityData?.name ?? '',
    result,
    shouldAutoRun: Boolean(result),
    shouldFocusPostal: normalizeLocationValue(params.get('lookup')) === 'postal',
  }
}

export function buildWaterHardnessUrl(
  currentHref,
  { province = '', city = '' } = {},
) {
  const url = new URL(currentHref, 'https://waterdoctor.ca')
  const normalizedProvince = province.trim()
  const normalizedCity = city.trim()

  url.searchParams.delete('province')
  url.searchParams.delete('city')
  url.searchParams.delete('lookup')

  if (normalizedProvince) {
    url.searchParams.set('province', normalizedProvince)
  }

  if (normalizedProvince && normalizedCity) {
    url.searchParams.set('city', normalizedCity)
  }

  return `${url.pathname}${url.search}${url.hash}`
}

export function buildHelpMeChooseHref(result) {
  if (result?.hardnessLevel !== 'Soft') return null

  const params = new URLSearchParams({
    wd_from: 'water-hardness',
    province: result.province,
    city: result.city,
  })

  return `/landings/help-me-choose?${params.toString()}`
}
